import {getAllCheckIn} from '../../services/CheckInServices'
import Swal from "sweetalert2";
import { getHTMLForSummaryPopup } from '../../utils/PopupUtils';

export function checkForDuplicateCheckIn(name, value, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
        getAllCheckIn(cookies)
      .then((data) => {

        let isUserExists = false;
        for(var i=0; i<data.salesrep_data.length; i++)    //Same Sales Representative Name mentioned it denoted already exist.
        {
          if((data.salesrep_data[i].entity_name) === value.trim().toUpperCase()
            && parseInt(existingId) !== data.salesrep_data[i].id){   
            
            console.log(`User exists with the name - ${value}`) 
            isUserExists = true;
            break;
          }
        }
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }

 
  export function showBillingPop(selectedCustomer){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'BILLING DETAILS',
          [
            {label: 'BILLING NAME', value: selectedCustomer.name},
            {label: 'SALES OFFICER', value: selectedCustomer.salesrep.name},
          
          ])
  }, '', 'info');
  }
  export function showCustomerSitePop(consignee){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'DELIVERY DETAILS',
          [
            {label: 'SITE NAME', value: consignee.name},
            {label: 'ADDRESS', value: consignee.address_1},
            {value: consignee.address_2},
            {value: consignee.address_3},
            {label: 'PROJECT/SITE', value: consignee.project_name},
          ])
  }, '', 'info');   
  }
  export function showDeliveryChallanPop(selected_DC){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'DELIVERY CHALLAN DETAILS',
          [
           {label: 'SO NO', value: selected_DC.work_schedule.sales_order_detail.sales_order.order_no},
          {label: 'DELIVERY CHALLAN DATE', value: selected_DC.delivery_challan_date},
           {label: 'DELIVERY DATE', value: selected_DC.work_schedule.sales_order_detail.product.name},
           {label: 'DC QTY', value: selected_DC.dc_qty},
           {label: 'VEHICLE', value: selected_DC.transport_mode === 'own'? selected_DC.vehicle.name : selected_DC.customer_vehicle_no},
           {label: 'TRANSPORT MODE', value: selected_DC.transport_mode}
        
          ])
  }, '', 'info');   

}

export function mapCheckoutToTableRow(checkout) {
  const dc = checkout?.delivery_challan || {};
  const ws = dc.work_schedule || {};
  const soDetail = ws.sales_order_detail || {};
  const so = soDetail.sales_order || {};
  const consignee = so.consignee || {};
  const customer = consignee.customer || {};
  const plant = ws.plant || {};
  const vehicle = dc.vehicle || {};
  return {
    id: checkout.id,
    checkout_no: checkout.checkout_no,
    dc_date: dc.delivery_challan_date,
    dc_no: `${dc.prefix || ''}${dc.delivery_challan_no || ''}`,
    dc_time: dc.delivery_challan_time,
    schedule_no: ws.schedule_no,
    sales_order_no: `${so.prefix || ''}${so.order_no || ''}`,
    customer_name: customer.name,
    consignee_name: consignee.name,
    project_name: consignee.project_name,
    plant: plant.alias_name,
    grade: soDetail.product?.name,
    driver_name: checkout.driver_name || dc.driver_name,
    driver_mobile_no: checkout.driver_mobile_no || dc.driver_mobile_no,
    dc_quantity: dc.dc_qty,
    vehicle_no: vehicle.name || dc.customer_vehicle_no || '',
  };
}

export function toQtyNumber(value) {
  const qty = parseFloat(value);
  return Number.isFinite(qty) ? qty : 0;
}

export function isClientAdjIncludedInInvoice(deliveryChallan) {
  const flag = deliveryChallan?.is_client_adj_qty_incld_inv;
  return flag === true || flag === 1 || flag === '1'
    || String(flag).toLowerCase() === 'true'
    || String(flag).toLowerCase() === 'yes';
}

export function computeAcceptedQtyFromDc(deliveryChallan, dcQtyOverride) {
  const dcQty = toQtyNumber(dcQtyOverride ?? deliveryChallan?.dc_qty);
  if (isClientAdjIncludedInInvoice(deliveryChallan)) {
    return dcQty;
  }
  return parseFloat((dcQty - toQtyNumber(deliveryChallan?.client_adjust_qty)).toFixed(2));
}

export function goToCheckInMainForm(navigate, location, returnTo) {
  if (returnTo) {
    navigate(returnTo, { replace: true });
    return;
  }
  if (location?.pathname === '/CheckIn') {
    window.location.assign('/CheckIn');
    return;
  }
  navigate('/CheckIn', { replace: true });
}

export const PENDING_CHECKIN_LIST_COLUMNS = [
  { fieldName: 'id', headerName: 'ROW_ACTIONS', size: 48 },
  { fieldName: 'vehicle_no', headerName: 'Vehicle No', size: 120 },
  { fieldName: 'checkout_no', headerName: 'Checkout No', size: 110 },
  { fieldName: 'plant', headerName: 'Plant', size: 110 },
  { fieldName: 'dc_no', headerName: 'Deliverychallan No', size: 130 },
  { fieldName: 'dc_date', headerName: 'Deliverychallan Date', size: 130 },
  { fieldName: 'dc_time', headerName: 'Deliverychallan Time', size: 130 },
  { fieldName: 'schedule_no', headerName: 'Schedule No', size: 100 },
  { fieldName: 'sales_order_no', headerName: 'SO No', size: 100 },
  { fieldName: 'customer_name', headerName: 'Customer', size: 180 },
  { fieldName: 'project_name', headerName: 'Site', size: 180 },
  { fieldName: 'grade', headerName: 'Grade', size: 180 },
  { fieldName: 'dc_quantity', headerName: 'DC Qty', size: 100 },
  { fieldName: 'driver_name', headerName: 'Driver Name', size: 180 },
  { fieldName: 'driver_mobile_no', headerName: 'Driver Mobile No', size: 180 },
];
